import React from 'react'
import ParentForm from 'components/account/Parents/Form'

const AccountForm = props => {
  return (
    <>
      <ParentForm primary {...props} />
    </>
  )
}

export default AccountForm
